import { API } from 'configs/api';
import { PlaybackDetailsResponse } from 'queries/details/usePlaybackDetailsQuery';
import { useQuery } from 'react-query';
import { useLocation, useParams } from 'react-router';
import { previewKeys } from './previewKeys';

import vehicleThumbnail1 from '../../assets/images/vehicle-thumbnails/vehicle1.png';
import vehicleThumbnail2 from '../../assets/images/vehicle-thumbnails/vehicle2.png';
import vehicleThumbnail3 from '../../assets/images/vehicle-thumbnails/vehicle3.png';
import vehicleThumbnail4 from '../../assets/images/vehicle-thumbnails/vehicle4.png';
import vehicleThumbnail5 from '../../assets/images/vehicle-thumbnails/vehicle5.png';
import vehicleThumbnail6 from '../../assets/images/vehicle-thumbnails/vehicle6.png';
import vehicleThumbnail7 from '../../assets/images/vehicle-thumbnails/vehicle7.png';

import { useCookies } from 'react-cookie';
import { InventoryItemMedia } from 'types';
import { ensureVisitorCode } from 'utils/ensureVisitorCode';

type PreviewParams = {
  landingPageDesignId: number;
  showSalesContent?: boolean;
  showServiceContent?: boolean;
  shortUrl?: string;
};

const VEHICLE_THUMBNAILS = [
  vehicleThumbnail1,
  vehicleThumbnail2,
  vehicleThumbnail3,
  vehicleThumbnail4,
  vehicleThumbnail5,
  vehicleThumbnail6,
  vehicleThumbnail7,
];

const getPreviewData = async ({
  landingPageDesignId,
  showSalesContent,
  showServiceContent,
  shortUrl,
}: PreviewParams): Promise<PlaybackDetailsResponse> => {
  const response = await API.get(
    `/playback/${landingPageDesignId}/preview?showSalesContent=${showSalesContent}&showServiceContent=${showServiceContent}&shortUrl=${shortUrl || ''}`
  );

  return response.data;
};

export const usePreviewQuery = () => {
  const { landingPageDesignId, shortUrl } = useParams();
  const { search } = useLocation();
  const [cookies] = useCookies(['covideo-preview-data']);

  const query = new URLSearchParams(search);
  const salesQueryParams = query.get('showSalesContent');
  const serviceQueryParam = query.get('showServiceContent');
  const showSalesContent =
    salesQueryParams !== null && salesQueryParams === 'true';
  const showServiceContent =
    serviceQueryParam !== null && serviceQueryParam === 'true';

  const lpDesignId = Number(landingPageDesignId || 0);

  return useQuery(
    previewKeys.single(lpDesignId),
    () =>
      getPreviewData({
        landingPageDesignId: lpDesignId,
        showSalesContent,
        showServiceContent,
        shortUrl,
      }),
    {
      enabled: !isNaN(lpDesignId),
      select: (data: PlaybackDetailsResponse) => {
        if (showSalesContent) {
          return {
            ...data,
            inventoryItem: {
              ...data.inventoryItem,
              media: data.inventoryItem?.media?.map(
                (mediaItem: InventoryItemMedia, index: number) => ({
                  ...mediaItem,
                  mediaSource: VEHICLE_THUMBNAILS[index],
                })
              ),
            },
          };
        }

        if (showServiceContent) {
          const cookieRepairOrder =
            cookies['covideo-preview-data']?.repairOrder;

          return {
            ...data,
            repairOrder: {
              ...data.repairOrder,
              ...cookieRepairOrder,
            },
          };
        }

        return data;
      },
      onSuccess(data) {
        if (data.reactionsEnabled) {
          ensureVisitorCode();
        }
      },
    }
  );
};
